export const SET_EINGABEARTEN = 'set_eingabearten';
export const SET_EINGABEARTEN_LOADED = 'set_eingabearten_loaded';

export const SET_PRUEFAKTIONEN = 'set_pruefaktionen';
export const SET_PRUEFAKTIONEN_LOADED = 'set_pruefaktionen_loaded';

export const SET_WARENEINGANGSPRUEFUNG_STATI = 'set_wareningangspruefung_stati';
export const SET_WARENEINGANGSPRUEFUNG_STATI_LOADED = 'set_wareningangspruefung_stati_loaded';
